export enum DesktopAudioRecordingStrategy {
  WebArtifact = "web-artifact",
  DesktopArtifact = "desktop-artifact",
}

export type DesktopRecordingStartAttemptTrace = {
  rootStartAttemptId: string;
  startAttemptId: string;
  attemptNumber: number;
};

/**
 * Keep in sync with identical definitions in:
 * - mem-client-desktop/preload/types.ts (preload compilation unit)
 * - mem-client-desktop/src/modules/recording-coordinator/types.ts (main process)
 */
export type DesktopRecallStartRecordingArgs = {
  audioRecordingId: string;
  windowId: string;
  uploadToken: string;
  recordingStrategy: DesktopAudioRecordingStrategy;
  calendarEventId?: string;
  startAttemptTrace?: DesktopRecordingStartAttemptTrace;
  expectedWindowId?: string;
};

export type DesktopRecallReplaceRecordingArgs = DesktopRecallStartRecordingArgs & {
  previousAudioRecordingId: string;
};
